export const sidebarCompressedWidth = 56;
export const sidebarEnlargedWidth = 240;
